var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 12,
    rx: 6,
    fill: "#2A2A2B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.0218 9V4.09091H6.97741V9H6.0218ZM6.50439 3.33345C6.3382 3.33345 6.19545 3.27805 6.07613 3.16726C5.95894 3.05433 5.90035 2.9201 5.90035 2.76456C5.90035 2.60689 5.95894 2.47266 6.07613 2.36186C6.19545 2.24893 6.3382 2.19247 6.50439 2.19247C6.67059 2.19247 6.81228 2.24893 6.92947 2.36186C7.04878 2.47266 7.10844 2.60689 7.10844 2.76456C7.10844 2.9201 7.04878 3.05433 6.92947 3.16726C6.81228 3.27805 6.67059 3.33345 6.50439 3.33345Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI);
export default __webpack_public_path__ + "static/media/i.945b7e06cff503d56928ad9558468231.svg";
export { ForwardRef as ReactComponent };